export const extra = {
  fr: {
    wa: {
      note: "Le contact se fait uniquement par WhatsApp",
      number: "+33 6 50 26 71 60",
      cta: "Discuter sur WhatsApp",
      availability: "Réponse rapide, 7j/7",
      msgVisit: "Bonjour, je souhaite demander une visite d'un bien immobilier.",
      msgContact: "Bonjour, je souhaite vous contacter au sujet d'un bien immobilier.",
      msgQuote: (pkg) => `Bonjour, je souhaite un devis pour le forfait ${pkg}.`,
    },
    testimonials: {
      eyebrow: "ILS NOUS FONT CONFIANCE",
      title: "Ce que disent nos clients",
      sub: "Acheteurs et investisseurs à distance, partout en Europe.",
      items: [
        { name: "Amine K.", location: "Paris → Prizren", text: "J'ai acheté un appartement à Prizren sans quitter Paris. Le rapport photo était d'une précision remarquable." },
        { name: "Lejla H.", location: "Bâle → Sarajevo", text: "La vidéo 4K m'a évité un aller-retour inutile. J'ai vu chaque pièce comme si j'y étais." },
        { name: "Sophie M.", location: "Genève → Paris", text: "Clair, rapide et honnête : le rapport a signalé deux défauts invisibles sur les photos de l'annonce." },
        { name: "Dino S.", location: "Zurich → Sarajevo", text: "Toutes mes questions ont été posées au vendeur et les réponses enregistrées. Service impeccable." },
        { name: "Claire B.", location: "Lyon → Bâle", text: "Une visite organisée en 48 heures. Le rapport écrit a convaincu ma banque." },
        { name: "Arben G.", location: "Lausanne → Prizren", text: "Parfait pour la diaspora : je sais enfin exactement ce que j'achète au pays." },
        { name: "Nadia R.", location: "Paris → Sarajevo", text: "L'appel de débriefing après la visite change tout. Rien n'est resté flou." },
        { name: "Emir T.", location: "Mulhouse → Prizren", text: "Inspection d'un terrain avec photos aériennes des limites. Exactement ce qu'il me fallait avant de signer." },
        { name: "Julien P.", location: "Bordeaux → Paris", text: "Sérieux, discret et ponctuel. La vidéo des parties communes m'a beaucoup rassuré." },
        { name: "Vesna D.", location: "Strasbourg → Sarajevo", text: "Je loue à distance en toute sérénité grâce à leurs états des lieux visuels." },
      ],
    },
  },
  en: {
    wa: {
      note: "Contact is exclusively via WhatsApp",
      number: "+33 6 50 26 71 60",
      cta: "Chat on WhatsApp",
      availability: "Fast reply, 7 days a week",
      msgVisit: "Hello, I would like to request a property visit.",
      msgContact: "Hello, I would like to contact you about a property.",
      msgQuote: (pkg) => `Hello, I would like a quote for the ${pkg} package.`,
    },
    testimonials: {
      eyebrow: "THEY TRUST US",
      title: "What our clients say",
      sub: "Remote buyers and investors, all over Europe.",
      items: [
        { name: "Amine K.", location: "Paris → Prizren", text: "I bought an apartment in Prizren without leaving Paris. The photo report was remarkably precise." },
        { name: "Lejla H.", location: "Basel → Sarajevo", text: "The 4K video saved me a pointless round trip. I saw every room as if I were there." },
        { name: "Sophie M.", location: "Geneva → Paris", text: "Clear, fast and honest: the report flagged two flaws invisible in the listing photos." },
        { name: "Dino S.", location: "Zurich → Sarajevo", text: "All my questions were put to the seller and the answers recorded. Impeccable service." },
        { name: "Claire B.", location: "Lyon → Basel", text: "A viewing arranged within 48 hours. The written report convinced my bank." },
        { name: "Arben G.", location: "Lausanne → Prizren", text: "Perfect for the diaspora: I finally know exactly what I'm buying back home." },
        { name: "Nadia R.", location: "Paris → Sarajevo", text: "The debriefing call after the visit changes everything. Nothing was left unclear." },
        { name: "Emir T.", location: "Mulhouse → Prizren", text: "Plot inspection with aerial photos of the boundaries. Exactly what I needed before signing." },
        { name: "Julien P.", location: "Bordeaux → Paris", text: "Serious, discreet and punctual. The video of the common areas was very reassuring." },
        { name: "Vesna D.", location: "Strasbourg → Sarajevo", text: "I rent remotely with total peace of mind thanks to their visual check-in reports." },
      ],
    },
  },
  bs: {
    wa: {
      note: "Kontakt isključivo putem WhatsAppa",
      number: "+33 6 50 26 71 60",
      cta: "Razgovarajte na WhatsAppu",
      availability: "Brz odgovor, 7 dana u sedmici",
      msgVisit: "Dobar dan, želim zatražiti posjetu nekretnini.",
      msgContact: "Dobar dan, želim vas kontaktirati u vezi nekretnine.",
      msgQuote: (pkg) => `Dobar dan, želim ponudu za paket ${pkg}.`,
    },
    testimonials: {
      eyebrow: "ONI NAM VJERUJU",
      title: "Šta kažu naši klijenti",
      sub: "Kupci i investitori na daljinu, širom Evrope.",
      items: [
        { name: "Amine K.", location: "Pariz → Prizren", text: "Kupio sam stan u Prizrenu bez odlaska iz Pariza. Foto izvještaj je bio izuzetno precizan." },
        { name: "Lejla H.", location: "Basel → Sarajevo", text: "4K video me je poštedio bespotrebnog putovanja. Vidio sam svaku prostoriju kao da sam tamo." },
        { name: "Sophie M.", location: "Ženeva → Pariz", text: "Jasno, brzo i pošteno: izvještaj je otkrio dva nedostatka nevidljiva na fotografijama oglasa." },
        { name: "Dino S.", location: "Zürich → Sarajevo", text: "Sva moja pitanja su postavljena prodavcu, a odgovori snimljeni. Besprijekorna usluga." },
        { name: "Claire B.", location: "Lyon → Basel", text: "Posjeta organizirana za 48 sati. Pisani izvještaj je uvjerio moju banku." },
        { name: "Arben G.", location: "Lausanne → Prizren", text: "Savršeno za dijasporu: konačno znam tačno šta kupujem kod kuće." },
        { name: "Nadia R.", location: "Pariz → Sarajevo", text: "Razgovor nakon posjete mijenja sve. Ništa nije ostalo nejasno." },
        { name: "Emir T.", location: "Mulhouse → Prizren", text: "Inspekcija zemljišta sa zračnim snimcima granica. Upravo ono što mi je trebalo prije potpisa." },
        { name: "Julien P.", location: "Bordeaux → Pariz", text: "Ozbiljno, diskretno i tačno. Video zajedničkih prostorija me je mnogo uvjerio." },
        { name: "Vesna D.", location: "Strasbourg → Sarajevo", text: "Iznajmljujem na daljinu s potpunim mirom zahvaljujući njihovim vizuelnim zapisnicima." },
      ],
    },
  },
  sq: {
    wa: {
      note: "Kontakti bëhet vetëm përmes WhatsApp",
      number: "+33 6 50 26 71 60",
      cta: "Bisedoni në WhatsApp",
      availability: "Përgjigje e shpejtë, 7 ditë në javë",
      msgVisit: "Përshëndetje, dëshiroj të kërkoj një vizitë prone.",
      msgContact: "Përshëndetje, dëshiroj t'ju kontaktoj për një pronë.",
      msgQuote: (pkg) => `Përshëndetje, dëshiroj një ofertë për paketën ${pkg}.`,
    },
    testimonials: {
      eyebrow: "ATA NA BESOJNË",
      title: "Çfarë thonë klientët tanë",
      sub: "Blerës dhe investitorë nga distanca, në gjithë Evropën.",
      items: [
        { name: "Amine K.", location: "Paris → Prizren", text: "Bleta një apartament në Prizren pa lëvizur nga Parisi. Raporti fotografik ishte jashtëzakonisht i saktë." },
        { name: "Lejla H.", location: "Basel → Sarajevë", text: "Videoja 4K më kurseu një udhëtim të kotë. Pashë çdo dhomë sikur të isha aty." },
        { name: "Sophie M.", location: "Gjenevë → Paris", text: "E qartë, e shpejtë dhe e sinqertë: raporti zbuloi dy defekte të padukshme në fotot e shpalljes." },
        { name: "Dino S.", location: "Cyrih → Sarajevë", text: "Të gjitha pyetjet e mia iu drejtuan shitësit dhe përgjigjet u regjistruan. Shërbim i përpiktë." },
        { name: "Claire B.", location: "Lyon → Basel", text: "Vizitë e organizuar brenda 48 orësh. Raporti i shkruar e bindi bankën time." },
        { name: "Arben G.", location: "Lozanë → Prizren", text: "Perfekte për diasporën: më në fund e di saktësisht çka blej në atdhe." },
        { name: "Nadia R.", location: "Paris → Sarajevë", text: "Telefonata pas vizitës ndryshon gjithçka. Asgjë nuk mbeti e paqartë." },
        { name: "Emir T.", location: "Mulhouse → Prizren", text: "Inspektim trualli me foto ajrore të kufijve. Pikërisht çka më duhej përpara nënshkrimit." },
        { name: "Julien P.", location: "Bordeaux → Paris", text: "Seriozë, diskretë dhe të saktë. Videoja e hapësirave të përbashkëta më qetësoi shumë." },
        { name: "Vesna D.", location: "Strasbourg → Sarajevë", text: "Jap me qira nga distanca me qetësi të plotë falë procesëve-verbale vizuale të tyre." },
      ],
    },
  },
  ar: {
    nav: { services: "خدماتنا", packages: "الباقات", zones: "مناطق التدخل", process: "كيف نعمل", faq: "الأسئلة الشائعة", contact: "اتصل بنا", book: "اطلب زيارة" },
    hero: {
      eyebrow: "ATLAS PROPERTY INTELLIGENCE · باريس — بازل — سراييفو — بريزرن",
      line1: "أنت بعيد.",
      line2: "نحن عيناك",
      line3: "في الميدان.",
      sub: "نزور العقار نيابة عنك: صور عالية الدقة، فيديو 4K، ملاحظات بصرية وتقرير واضح قبل أن تشتري أو تستثمر أو تستأجر.",
      ctaPrimary: "اطلب زيارة",
      ctaSecondary: "اكتشف باقاتنا",
      stats: [
        { value: "48 سا", label: "زيارة خلال 48 ساعة" },
        { value: "4", label: "مدن مغطاة" },
        { value: "4K", label: "فيديو غامر" },
      ],
    },
    marquee: ["باريس", "بازل", "سراييفو", "بريزرن", "زيارة خلال 48 ساعة", "فيديو 4K غامر", "تقرير واضح ومصوّر", "سرية وخصوصية تامة", "عرض سعر مخصص"],
    services: {
      eyebrow: "خدماتنا",
      title: "انظر قبل أن تقرر",
      sub: "المشتري الذكي لا يوقّع أبداً بعينين مغمضتين. نذهب إلى الموقع نيابة عنك ونوثّق كل التفاصيل.",
      imageCaption: "تغطية حقيقية — صالون، إقامة راقية",
      cards: [
        { title: "زيارة ميدانية", text: "يقوم مفتش بزيارة العقار فعلياً: المدخل، المناطق المشتركة، الشارع والمحيط المباشر." },
        { title: "صور HD وفيديو 4K", text: "تغطية مصوّرة عالية الدقة وفيديو مستمر ومثبّت لكل غرفة، دون مونتاج مضلل." },
        { title: "ملاحظات بصرية", text: "شقوق ظاهرة، آثار رطوبة، حالة النوافذ، التعرض للشمس، الضوضاء: كل شيء يُسجَّل." },
        { title: "تقرير واضح", text: "ملف منظم ومصوّر يُسلَّم بسرعة، مع إجابات عن أسئلتك المحددة." },
      ],
    },
    cities: {
      eyebrow: "مناطق التدخل",
      title: "أربع مناطق، معيار واحد",
      sub: "حضور محلي في كل مدينة، لزيارات سريعة ومعرفة حقيقية بالميدان.",
      items: [
        { name: "باريس", country: "فرنسا", tag: "هوسمان والفخامة", coords: "48.8566° N · 2.3522° E", blurb: "شقق هوسمانية ومبانٍ سكنية وعقارات فاخرة في جميع أنحاء العاصمة." },
        { name: "بازل", country: "سويسرا", tag: "المثلث الحدودي والمعايير السويسرية", coords: "47.5596° N · 7.5886° E", blurb: "بازل وضواحيها: دقة والتزام ومعايير سويسرية." },
        { name: "سراييفو", country: "البوسنة والهرسك", tag: "عاصمة صاعدة", coords: "43.8563° N · 18.4131° E", blurb: "المركز التاريخي ومشاريع جديدة ومبانٍ سكنية في نمو سريع." },
        { name: "بريزرن", country: "كوسوفو", tag: "التراث والمغتربون", coords: "42.2139° N · 20.7397° E", blurb: "أكثر مدن كوسوفو سياحة، في قلب استثمارات المغتربين." },
      ],
    },
    packages: {
      eyebrow: "باقاتنا",
      title: "باقات واضحة وعرض سعر مخصص",
      sub: "كل عقار فريد: يُحدَّد السعر بعرض مخصص، دون مفاجآت ودون التزام.",
      priceLabel: "عرض سعر مخصص",
      cta: "اطلب عرض سعر",
      popular: "الأكثر طلباً",
      bestFor: "مثالي لـ",
      items: [
        { id: "essentiel", name: "Essentiel", headline: "زيارة ولقطات أساسية", tag: "فحص سريع", features: ["زيارة ميدانية فعلية خلال 48 ساعة", "حزمة 25+ صورة عالية الدقة", "فحص المداخل والمناطق المشتركة وصندوق البريد", "التحقق من التعرض للشمس والضوضاء المحيطة", "تسليم آمن لتقرير الصور خلال 24 ساعة"], bestFor: "المشترين المستعجلين أو الفحص المبدئي لإعلان مشبوه" },
        { id: "video", name: "Vidéo", headline: "صور وفيديو 4K وإجابات مخصصة", tag: "تجربة غامرة", features: ["كل ما في باقة Essentiel", "فيديو 4K مستمر ومثبّت (الطريق، الشارع، المدخل، كل غرفة)", "تسجيل فتح/إغلاق النوافذ والحنفيات", "طرح أسئلتك على المالك أو الحارس", "مراجعة صوتية بتعليقات موقوتة"], bestFor: "المشترين على بعد أكثر من 500 كم أو المغتربين" },
        { id: "premium", name: "Premium", headline: "زيارة كاملة وتقرير مفصّل", tag: "موصى به للمستثمرين", popular: true, features: ["كل ما في باقة Vidéo (صور HD + فيديو مثبّت)", "تقرير PDF بصري من 15+ صفحة", "تسجيل الشقوق وآثار الرطوبة وحالة النوافذ", "تحليل المحيط المباشر (متاجر، مواصلات، إطلالات)", "مكالمة مناقشة شخصية لمدة 30 دقيقة"], bestFor: "قرارات الشراء الاستراتيجية أو الزيارة الحاسمة" },
        { id: "investissement", name: "Investissement", headline: "عقارات وأراضٍ وتنسيق خبراء", tag: "حسب الطلب ومتعدد القطع", features: ["فحص كامل للعقارات المعقدة أو المباني أو الأراضي", "لقطات جوية أو محيطية لحدود القطعة", "تنسيق واستقبال الحرفيين أو المقيّمين في الموقع", "ملف تقني موحّد للبنوك والموثّقين", "جهة اتصال مخصصة ذات أولوية 7 أيام في الأسبوع"], bestFor: "تجار العقارات والصناديق الخاصة ومشتري الأراضي" },
      ],
    },
    process: {
      eyebrow: "كيف نعمل",
      title: "من طلبك إلى التقرير في 4 خطوات",
      steps: [
        { title: "طلب عبر الإنترنت", text: "املأ النموذج: عنوان العقار ورابط الإعلان والباقة المطلوبة." },
        { title: "تواصل وتأكيد", text: "نؤكد الجدوى وعرض السعر وتاريخ الزيارة خلال 24 ساعة عمل." },
        { title: "زيارة وتغطية", text: "يتوجه مفتشنا إلى الموقع ويوثّق العقار بالصور والفيديو." },
        { title: "تسليم ومناقشة", text: "تستلم الملف الكامل وتناقش معنا النقاط الأساسية." },
      ],
    },
    faq: {
      eyebrow: "الأسئلة الشائعة",
      title: "أسئلة متكررة",
      items: [
        { q: "هل تحل زياراتكم محل الخبرة الرسمية؟", a: "لا. خدماتنا ملاحظات بصرية وتقارير واقعية. لا تحل محل الخبرة التقنية للمباني أو الفحوصات الإلزامية أو الاستشارة القانونية." },
        { q: "كم تستغرق الزيارة؟", a: "عادةً خلال 48 ساعة من الموافقة على عرض السعر، حسب توفر البائع أو الوكالة. ثم يصلك الملف خلال 24 ساعة." },
        { q: "كيف تُحتسب أسعاركم؟", a: "كل مهمة تُقيَّم بعرض سعر مخصص حسب المدينة وحجم العقار والباقة المختارة. لا رسوم خفية: أنت توافق على العرض قبل أي عمل." },
        { q: "هل يمكنني طرح أسئلة محددة على المالك؟", a: "نعم. مع باقات Vidéo وPremium وInvestissement نطرح أسئلتك في الموقع ونسجّل الإجابات في التقرير." },
        { q: "هل تعملون خارج المدن الأربع المذكورة؟", a: "أحياناً، حول بازل ولطلبات محددة. صف حاجتك في النموذج وسنجيبك بصراحة عن الجدوى." },
        { q: "هل بياناتي الشخصية محمية؟", a: "نعم. بيانات الاتصال وعناوين العقارات تُخزَّن بأمان ولا تُشارك أبداً مع أطراف ثالثة." },
      ],
    },
    contact: {
      eyebrow: "اتصل بنا",
      title: "لنتحدث عن عقارك",
      sub: "صف مشروعك في بضعة أسطر: نرد عليك خلال 24 ساعة عمل.",
      responseLabel: "رد خلال 24 ساعة عمل",
      zonesLabel: "باريس · بازل · سراييفو · بريزرن",
      cta: "اطلب زيارة",
    },
    form: {
      title: "اطلب زيارة",
      sub: "املأ هذا النموذج: يُسجَّل طلبك فوراً ويُعالَج خلال 24 ساعة عمل.",
      name: "الاسم الكامل", email: "البريد الإلكتروني", phone: "الهاتف", city: "مدينة العقار", cityOther: "مدينة أخرى",
      address: "عنوان العقار", listing: "رابط الإعلان (URL)", type: "نوع العقار",
      types: ["شقة", "منزل", "مبنى", "أرض", "محل تجاري"],
      packageLabel: "الباقة المطلوبة", date: "التاريخ المفضل", message: "رسالة",
      messagePlaceholder: "أخبرنا بما يهمك: نقاط للتحقق، أسئلة للبائع، قيود زمنية…",
      submit: "أرسل طلبي", sending: "جارٍ الإرسال…",
      successTitle: "تم استلام الطلب",
      successText: "تم تسجيل طلبك بالمرجع",
      successFollow: "سنتواصل معك خلال 24 ساعة عمل على العنوان المذكور.",
      newRequest: "طلب آخر", backHome: "العودة إلى الرئيسية",
      error: "حدث خطأ. حاول مرة أخرى.",
      disclaimer: "بياناتك تبقى سرية ولا تُشارك أبداً. زياراتنا ملاحظات بصرية: لا تحل محل خبرة مهنية رسمية.",
      selectPlaceholder: "اختر…",
    },
    footer: {
      tagline: "أنت بعيد. نحن عيناك في الميدان.",
      nav: "التنقل",
      rights: "جميع الحقوق محفوظة.",
      disclaimer: "تنبيه: تجري ATLAS PROPERTY INTELLIGENCE زيارات ملاحظة بصرية وتقارير واقعية. خدماتنا ليست خبرة تقنية للمباني ولا تشخيصاً عقارياً معتمداً ولا استشارة قانونية.",
    },
    statuses: { nouvelle: "جديد", devis_envoye: "أُرسل العرض", acceptee: "مقبول", planifiee: "مجدول", terminee: "مكتمل" },
    wa: {
      note: "التواصل حصرياً عبر واتساب",
      number: "+33 6 50 26 71 60",
      cta: "تحدث عبر واتساب",
      availability: "رد سريع، 7 أيام في الأسبوع",
      msgVisit: "مرحباً، أرغب في طلب زيارة عقار.",
      msgContact: "مرحباً، أرغب في التواصل معكم بخصوص عقار.",
      msgQuote: (pkg) => `مرحباً، أرغب في عرض سعر لباقة ${pkg}.`,
    },
    testimonials: {
      eyebrow: "يثقون بنا",
      title: "ماذا يقول عملاؤنا",
      sub: "مشترون ومستثمرون عن بُعد في جميع أنحاء أوروبا.",
      items: [
        { name: "أمين ك.", location: "باريس → بريزرن", text: "اشتريت شقة في بريزرن دون مغادرة باريس. كان تقرير الصور دقيقاً بشكل ملحوظ." },
        { name: "ليلى ح.", location: "بازل → سراييفو", text: "وفّر عليّ فيديو 4K رحلة ذهاب وعودة بلا فائدة. رأيت كل غرفة وكأنني هناك." },
        { name: "صوفي م.", location: "جنيف → باريس", text: "واضح وسريع وصادق: أشار التقرير إلى عيبين غير مرئيين في صور الإعلان." },
        { name: "دينو س.", location: "زيورخ → سراييفو", text: "طُرحت كل أسئلتي على البائع وسُجّلت الإجابات. خدمة لا تشوبها شائبة." },
        { name: "كلير ب.", location: "ليون → بازل", text: "زيارة نظُّمت خلال 48 ساعة. التقرير المكتوب أقنع مصرفي." },
        { name: "أربن غ.", location: "لوزان → بريزرن", text: "مثالي للمغتربين: أعرف أخيراً بالضبط ما أشتريه في الوطن." },
        { name: "نادية ر.", location: "باريس → سراييفو", text: "مكالمة المناقشة بعد الزيارة تغيّر كل شيء. لم يبقَ شيء غامض." },
        { name: "أمير ت.", location: "ميلوز → بريزرن", text: "فحص أرض بصور جوية للحدود. بالضبط ما احتجته قبل التوقيع." },
        { name: "جوليان ب.", location: "بوردو → باريس", text: "جدية وسرية والتزام بالمواعيد. فيديو المناطق المشتركة طمأنني كثيراً." },
        { name: "فيسنا د.", location: "ستراسبورغ → سراييفو", text: "أؤجّر عن بُعد براحة بال تامة بفضل تقاريرهم البصرية." },
      ],
    },
  },
};
